import React from 'react';
import { IoHeartOutline } from 'react-icons/io5';
import './Care.css';

/**
 * Care icon — a heart in the unified header. Clicking it opens the
 * unified Care dashboard (App.js owns the dashboard state). The old
 * inline account-list popover is gone; account switching lives in the
 * dashboard rail now.
 */
export default function CareIcon({ onOpen }) {
  return (
    <div className="mcv-settings-wrapper">
      <button
        className="mcv-settings-btn"
        onClick={() => onOpen?.()}
        title="Care — manage someone's account"
        aria-label="Care"
      >
        <IoHeartOutline />
      </button>
    </div>
  );
}
